import { makeSurfaceToken } from '@utils/css';

const linkSurface = makeSurfaceToken("--slider-link", {
  color: "255 255 255",
  background: "0 0 0 / 0.8"
});
const root = "_b7nr1h3viof";
const imageWrapper = "_b7ni1j1qy44";
const imageButton = "_b7ni1iayfxa";
const imageCls = "_b7ni1lch27o";
const link = "_b7nlozav76";

export { imageButton, imageCls, imageWrapper, link, linkSurface, root };
import "./atom.slide.style.linaria.module.css";
//# sourceMappingURL=atom.slide.style.js.map
